import { CreateUserFilterInput, UserFilter } from '@/API.ts';
import { FilterDefinition } from '@lambda-layer/models/FilterDefinition/FilterDefinition.ts';
import { GenericService } from '@/service/GenericService.ts';
import {
  onCreateUserFilter,
  onDeleteUserFilter,
} from '@/graphql/subscriptions.ts';
import { ListType } from '@/service/ExportJobService.ts';
import { FilterSelections } from '@lambda-layer/types/filter.ts';

/**
 * Service for managing user house list FilterPage selections.
 */
export class UserFilterService extends GenericService<UserFilter> {
  async onCreateEvent<T>(execute: (data: T) => void) {
    return await this.onEvent(execute, onCreateUserFilter);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async onUpdateEvent<T>(_: (data: T) => void) {
    return Promise.resolve(undefined);
  }

  async onDeleteEvent<T>(execute: (data: T) => void) {
    return await this.onEvent(execute, onDeleteUserFilter);
  }

  async createUserFilter(
    name: string,
    listType: ListType,
    filterDefinitions: FilterDefinition[],
    filterSelections: FilterSelections
  ) {
    const userFilter = {
      name,
      listType,
      filterSelections: JSON.stringify(
        Object.fromEntries(
          Object.entries(filterSelections)
            .filter(
              ([, filterRowSelection]) => filterRowSelection.value.length > 0
            )
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            .map(([id, { externalUpdateHash, ...filterRowSelection }]) => {
              return [id, filterRowSelection];
            })
        )
      ),
      filterDefinitions: JSON.stringify(
        FilterDefinition.simplify(filterDefinitions)
      ),
    } as CreateUserFilterInput;
    return await this.repository.save(userFilter);
  }
}
